// input file
let textInput = [];
const dropZone = document.querySelectorAll('.fileinput2');

function createArrayNameFile(file, fileExtension) {
    if (file) {
        if ($.inArray(file.name.split('.').pop().toLowerCase(), fileExtension) === -1) {
            $.fancybox.open(`<div><p class="text text_c-gray">Недопустимый тип файла: ${file.name}</p></div>`);
        } else {
            const reader = new FileReader();

            reader.readAsDataURL(file);
            textInput.push(file.name);
        }
    }
}

dropZone.forEach((item) => {
    item.querySelector('.fileinput2__input')?.addEventListener('change', (e) => {
        const target = e.target;
        const files = target.files;
        const elFileinput = item.querySelector('.fileinput2__name');
        const isDoc = item.classList.contains('fileinput2_doc');
        const isPic = item.classList.contains('fileinput2_pic');

        textInput = [];

        if (isDoc && isPic) {
            Array.from(files).forEach((file) => createArrayNameFile(file, ['docx', 'pdf', 'jpg', 'jpeg', 'png']));
        } else if (isDoc) {
            Array.from(files).forEach((file) => createArrayNameFile(file, ['docx', 'pdf']));
        } else if (isPic) {
            Array.from(files).forEach((file) => createArrayNameFile(file, ['jpg', 'jpeg', 'png']));
        }

        if (textInput.length) {
            elFileinput.innerHTML = textInput.join(', ');
        }
    }, true);
});